import React, { Component } from 'react';
import {connect} from 'react-redux';
import { CONFIG } from '../../../../config';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import Loader from '../../../Loader';
import LoaderModal from '../../../modal/LoaderModal';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import accountManagement from '../../../../apis/accountManagement';
import DropdownUploadHistory from '../masterDropDown/DropdownUploadHistory';
import FilterSoal from '../../../../entity/FilterSoal';
import { Button, Row, Col, Alert, Table} from 'react-bootstrap';

class MgtSoal extends Component {
    constructor(props) {
        super(props);
        this.state = {             
            uploadHis: [],
            soals:[], 
            error: null,
            resMessage: {},
            isFetching: false,
            isSearch: false,
            showAlert: false,
            idUploadHis: null
        }
        this.handleChange = this.handleChange.bind(this);
    }
    async componentDidMount() {
        document.title = "Manage Soal";
        this.setState({ isFetching: true });
        await this.props.cekCookies(); 
        if(!__.isEmpty(this.props.account)){
            this.fetchUploadHis(this.props.account.idAdmin); 
        }

        var stateLoc = this.props.location.state;
        if(stateLoc !== undefined) {
            this.setState({ idUploadHis: stateLoc.idUploadHistory });            
            this.fetchSoals(stateLoc.idUploadHistory)
        } 

        (function () {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://s3edubucket.s3-ap-southeast-1.amazonaws.com/javascripts/MathJax-2.7.5/MathJax.js?config=TeX-MML-AM_CHTML";
        
            var config = 'MathJax.Hub.Config({' +
                'extensions: ["tex2jax.js"],' +
                'jax: ["input/TeX","output/HTML-CSS"]' +
                '});' +
                'MathJax.Hub.Startup.onload();';
        
            if (window.opera) {
                script.innerHTML = config
            } else {
                script.text = config
            }
        
            script.addEventListener('load', function() {
                window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub], "");
            })
        
            document.getElementsByTagName("head")[0].appendChild(script);
        })();        
    }

    fetchUploadHis = async() => {
        this.setState({ uploadHis: [] });  
        const result = await accountManagement.get(CONFIG.SOAL_GET_UPLOAD_HISTORY)
            .catch(function(error){
                //this.setState({error});
                console.log(error)
            });
        
        if (result) {   
                if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){         
                this.setState({ 
                    uploadHis: result.data.data
                });   
            }       
            this.setState({ isFetching: false });       
        }            
    }

    fetchSoals = async(id) => {
        this.setState({ isSearch: true , soals:[] });
        const result = await accountManagement.post(CONFIG.SOAL_FILTERSOAL, {...FilterSoal,            
            idUploadHis: id,
            kodeOwner: 'PSEP'
        }).catch(function(error){
            console.log(error)
        });
        
        if (result) {  
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){          
                this.setState({ 
                    soals: result.data.data                    
                });   
            } else {
                this.setState({
                    showAlert: true,
                    resMessage: result.data.errorSchema.errorMessage
                })
            }   
            this.setState({ isSearch: false });            
        } 
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, ""]);
    }

    renderUploadHis = () => {
        if(__.isEmpty(this.state.uploadHis)){
            return ( <></> )
        }  
        return (
            <DropdownUploadHistory uploadHis={this.state.uploadHis} />
        )
    } 
    renderAlert = () => {
        const { showAlert,resMessage } = this.state;
      
        if (showAlert) {
          return (
            <Alert variant="info" onClose={() => this.setState({ showAlert: false })} dismissible>   
                <strong>{resMessage}</strong>
            </Alert>
          );
        } 
    }

    handleChange = (e) => {        
        //this.state.idUploadHis = e.target.value;
        this.setState({ idUploadHis: e.target.value });
    }
    
    btnTampil = async() => {
             
    } 
    
    renderKunciJawaban(kunciJawaban) {
        if(kunciJawaban === '1') 
            kunciJawaban = 'A';
        if(kunciJawaban === '2') 
            kunciJawaban = 'B';
        if(kunciJawaban === '3') 
            kunciJawaban = 'C';
        if(kunciJawaban === '4') 
            kunciJawaban = 'D';
        if(kunciJawaban === '5') 
            kunciJawaban = 'E';

        return kunciJawaban;
    }


    onDelete = async(id) => {
        this.setState({isFetching: true})        
        const res = await accountManagement.delete(CONFIG.SOAL_DELETE_BY_ID + id).catch(function(error){ console.log(error) })
        if(res){
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){       
                this.setState({ soals: this.state.soals.filter(item => item.idBankSoal !== id) })
            } else {
                this.setState({ showAlert: true, resMessage: res.data.errorSchema.errorMessage})
            }
            this.setState({ isFetching: false });
        } 
    }

    onEdit = id => {
        window.location.href = "/soal_edit/" + id +'/'+ this.state.idUploadHis;
    }
    


    render() {
        const {error, isFetching, soals} = this.state;
        if(error){
            return (<div>Error: {error.message}</div>)
        } 
        return ( 
            <div className="wrapper">
                <LoaderModal isFetching={isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'Management Banksoal'} />  
                    
                    {this.renderAlert()}   
                    
                        <Row>
                            <Col>
                                <div className="form-group">                                    
                                    <select className="form-control" name="upload" id="upload" 
                                        value={this.state.idUploadHis}
                                        onChange={(e) => this.setState({ idUploadHis: e.target.value })} >
                                        <option value="0">Pilih Upload History...</option>
                                        {this.renderUploadHis()}
                                    </select>
                                </div>
                            </Col>  
                            <Col>
                                <Button variant="outline-dark" onClick={() => this.fetchSoals(this.state.idUploadHis) } >Tampilkan Soal</Button>
                            </Col>
                        </Row>         

                    {this.loading()}
                    {soals.length > 0 &&                         
                        <Table bordered hover responsive="sm" style={{ marginTop:'10px'}}>
                            <thead>
                                <td width="10px">No</td>
                                <td width="20px">Tipe</td>
                                <td>Pertanyaan</td> 
                                <td>Pembahasan</td>                                
                                <td width="95px">Aksi</td>
                            </thead>
                            <tbody>
                                {soals.map((soal, i) =>                                 
                                    <tr key={i}>
                                        <td><p>{i+1}</p></td>
                                        <td><p>{soal.tipeSoal}</p></td>
                                        <td dangerouslySetInnerHTML={{__html: soal.pertanyaan}}></td>
                                        <td className="text-center">
                                            {(soal.isianJawaban === null || soal.isianJawaban === "") ? 
                                                <i className="text-danger fa fa-times"></i> : <i className="text-success fa fa-check"></i>
                                            }
                                        </td>
                                        <td>
                                        <div className="button-group pull-right">                                            
                                            <a className="btn btn-sm btn-warning" title="Edit..."
                                                href={"/soal_edit/" + soal.idBankSoal +'/'+ this.state.idUploadHis} >                                               
                                                <i className="fa fa-pencil"></i> </a>  &nbsp;     
                                            
                                            <button className="btn btn-sm btn-danger" title="Hapus..."
                                                onClick={() => {if (window.confirm('Konfirmasi Hapus ?')) this.onDelete(soal.idBankSoal) }}> 
                                                <i className="fa fa-remove"></i></button>
                                        </div>
                                        </td>                                       
                                        
                                        
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    }
                </div>
            </div>
         );
    }

    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    }
}

const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(MgtSoal); 